'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/search-bar/style/css.web.js
// module id = 300
// module chunks = 0